const PRODUCT_TYPES = {
    SIMPLE: 'simple',
    CONFIGURABLE: 'configurable',
    VIRTUAL: 'virtual',
};

const STOCK_STATUSES = {
    IN_STOCK: 'IN_STOCK',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
};

const VIP = 'vip';

const CREATE_ACCOUNT = 'account';

const COOKIE_CONSENT = 'cookie_consent';

const TEST_VERSION = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
};

const CHECKOUT_NOTICES = {
    payment_cancelled: 'Payment was cancelled. Your basket has been kept, so you can try again or choose another payment method.',
    payment_authentication_failed: 'Your bank could not confirm the payment (3D Secure). Please try again or use another card.',
    payment_declined: 'The payment was declined. Please try another card or payment method.',
    payment_failed: 'The payment could not be completed. Please try again.',
};

const CHECKOUT_NOTICE_COOKIE = 'checkout_notice';

export {
    PRODUCT_TYPES,
    STOCK_STATUSES,
    VIP,
    CREATE_ACCOUNT,
    COOKIE_CONSENT,
    TEST_VERSION,
    CHECKOUT_NOTICES,
    CHECKOUT_NOTICE_COOKIE,
};

